<template>

    <el-row>
        <el-table :data="this.result" ref="routeTable">
            <el-table-column label="SOC" prop="code" />
            <el-table-column label="LPN" prop="lpn" />
            <el-table-column label="RESULTADO" prop="status" />
        </el-table>
    </el-row>

</template>

<script>


export default {
  name: 'report',
  components: {
  },
  props: {
    result: Array,
  },
  data() {
    return {};
  },
};
</script>
